/* eslint-disable prettier/prettier */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PrivateRouteProps {
	children: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
	const location = useLocation();

	// Check if user is authenticated by checking for token and user data
	const isAuthenticated = () => {
		console.log('=== PRIVATE ROUTE AUTH CHECK ===');
		console.log('Current path:', location.pathname);

		try {
			const token = localStorage.getItem('token');
			const user = localStorage.getItem('user');

			console.log('Token exists:', !!token);
			console.log('User exists:', !!user);

			// Log actual values (first 20 chars only for security)
			if (token) {
				console.log('Token preview:', token.substring(0, 20) + '...');
			}
			if (user) {
				console.log(
					'User data preview:',
					user.substring(0, 50) + '...'
				);
			}

			// Both token and user must exist
			if (!token || !user) {
				console.log('Authentication FAILED: Missing token or user');
				return false;
			}

			// Try to parse user to verify it's valid JSON
			try {
				JSON.parse(user);
				console.log('Authentication PASSED');
				return true;
			} catch (parseError) {
				console.error(
					'Authentication FAILED: Invalid user JSON',
					parseError
				);
				return false;
			}
		} catch (error) {
			console.error('Authentication check error:', error);
			return false;
		} finally {
			console.log('=== END PRIVATE ROUTE AUTH CHECK ===');
		}
	};

	const authenticated = isAuthenticated();

	if (!authenticated) {
		console.log('Redirecting to /login from', location.pathname);
		// Redirect to login page but save the location they were trying to access
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	console.log('Rendering protected route:', location.pathname);
	return children;
};

export default PrivateRoute;
